import { getJson } from './http';

const BASE_URL = process.env.REACT_APP_BASE_URL?.replace(/\/$/, '') || '';

export async function listImageHistory({ tenant, limit = 100, offset = 0 }) {
  const q = new URLSearchParams({
    limit: String(limit),
    offset: String(offset),
  });
  // No headers; pass tenant in the URL like the rest of your API
  return getJson(`/api/history/${tenant}/images?${q.toString()}`);
}

export async function getPublicHistoryEnabled(tenant) {
  return getJson(`/api/history/${tenant}/public-history-enabled`);
}

export async function togglePublicVisibility(tenant, itemId, show) {
  const res = await fetch(`${BASE_URL}/api/history/${tenant}/items/${itemId}/public-visibility`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ show }),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

export async function toggleFilePublicVisibility(tenant, fileId, show) {
  const res = await fetch(`${BASE_URL}/api/history/${tenant}/files/${fileId}/public-visibility`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ show }),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

// ─── Article-style public event history ─────────────────────────────────────

/** Owner-facing payload for the article editor for one event. */
export async function getEventArticle(tenant, eventId) {
  return getJson(`/api/history/${tenant}/events/${eventId}/article`);
}

/** Persist the event's intro text, its public/hidden flag, and the chosen article template. */
export async function saveEventArticle(tenant, eventId, { intro, introPublic, template }) {
  const res = await fetch(`${BASE_URL}/api/history/${tenant}/events/${eventId}/article`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ intro, introPublic, template }),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}

/** Persist the tenant's custom caption for one media file. */
export async function saveFileCaption(tenant, fileId, caption) {
  const res = await fetch(`${BASE_URL}/api/history/${tenant}/files/${fileId}/caption`, {
    method: 'PUT',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ caption }),
  });
  if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
  return res.json();
}
